import { faBattery3, faLock, faWifi3 } from "@fortawesome/free-solid-svg-icons";
import { faSignal4 } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode } from "react";

export const Ipad = ({
    children,
    innerClassName,
    className,
    landscape,
    shadow,
    small,
}: {
    children: ReactNode;
    innerClassName?: string;
    className?: string;
    landscape?: boolean;
    shadow?: boolean;
    small?: boolean;
}) => {
    return (
        <div
            className={`
                relative ${className} 
                ${
                    !small
                        ? landscape
                            ? "h-[500px] w-[666px]"
                            : "h-[666px] w-[500px]"
                        : landscape
                        ? "h-[250px] w-[333px]"
                        : "h-[333px] w-[250px]"
                }
                ${small ? "p-2" : "p-4"}
                ${shadow && "shadow-2xl"}
                border  border-zinc-300 border-3 bg-zinc-800  rounded-[20px] ${className}
            `}
        >
            <div className="absolute bg-gradient-to-r from-zinc-300 via-zinc-200 to-zinc-300 h-[2px] w-7 -top-[2px] right-6 rounded-t-lg" />
            <div className="absolute bg-gradient-to-b from-zinc-300 to-zinc-200 h-5 w-[2px] top-8 -right-[3px] rounded-r-lg" />
            <div className="absolute bg-gradient-to-b from-zinc-300 to-zinc-200 h-5 w-[2px] top-14 -right-[3px] rounded-r-lg" />
            <div className="absolute top-[50%] -mt-[4.5px] left-[3px] bg-zinc-700 w-[9px] h-[9px] rounded-full p-[2px]">
                <div className="left-[50%] top-3 from-zinc-500 to-zinc-800 bg-gradient-to-bl w-full h-full rounded-full p-[1px]" />
            </div>
            <div className="w-full h-full bg-white rounded-[8px] overflow-hidden flex flex-col relative">
                <div className="shrink-0 h-3.5 bg-zinc-100 grid grid-cols-3 text-[5pt] text-zinc-800 px-1.5 items-center">
                    <div className="flex gap-1 justify-start">
                        <div>11:33</div>
                    </div>
                    <div className="flex justify-center items-center gap-0.5">
                        <div className="bg-zinc-400 rounded-full w-[3px] h-[3px]" />
                        <div className="bg-zinc-400 rounded-full w-[3px] h-[3px]" />
                        <div className="bg-zinc-400 rounded-full w-[3px] h-[3px]" />
                    </div>
                    <div className="flex gap-1 justify-end">
                        <FontAwesomeIcon fixedWidth className="" icon={faSignal4} />
                        <FontAwesomeIcon fixedWidth className="" icon={faWifi3} />
                        <FontAwesomeIcon fixedWidth className="" icon={faBattery3} />
                    </div>
                </div>
                <div className="shrink-0 h-[14px] pb-[5px] flex justify-center items-center bg-zinc-100">
                    <div className="text-[8px] flex items-center gap-1 justify-center relative">
                        <FontAwesomeIcon className="text-zinc-500" icon={faLock} />
                        reonic.com
                    </div>
                </div>
                <div className={`grow ${innerClassName}`}>{children}</div>
                <div className="absolute bottom-0 w-full flex justify-center h-2 z-10">
                    <div className="h-[3px] bg-black w-40 rounded-full" />
                </div>
            </div>
        </div>
    );
};

export const IPhone = ({
    innerClassName,
    className,
    landscape,
    shadow,
    whitebar,
    children,
    nobrowser,
}: {
    innerClassName?: string;
    className?: string;
    landscape?: boolean;
    shadow?: boolean;
    whitebar?: boolean;
    children: ReactNode;
    nobrowser?: boolean;
}) => {
    return (
        <div
            className={`
                h-[300px] w-[147px] bg-black p-[4px] rounded-[22px] border border-zinc-300
                ${shadow && "shadow-2xl"}
                ${className}
            `}
        >
            <div className="w-full h-full rounded-[18px] relative">
                {/* <div className="absolute -mt-1 bg-gradient-to-r from-zinc-300 via-zinc-200 to-zinc-300 h-[2px] w-6 -top-[2px] right-6 rounded-t-lg" /> */}
                <div className="absolute -ml-[3px] bg-gradient-to-b from-zinc-300 to-zinc-200 h-5 w-[2px] top-10 -left-[3px] rounded-l-lg" />
                <div className="absolute -ml-[3px] bg-gradient-to-b from-zinc-300 to-zinc-200 h-5 w-[2px] top-16 -left-[3px] rounded-l-lg" />
                <div
                    className={`h-full w-full rounded-[17px] relative z-20 flex flex-col overflow-hidden ${innerClassName}`}
                >
                    {!nobrowser && (
                        <div className="bg-zinc-100 flex flex-col w-full">
                            <div className="shrink-0 grow-0 w-full h-[12px] flex justify-between text-[5pt] text-zinc-800 px-[12px] items-center">
                                <div className="pl-[1px]">
                                    <div>11:33</div>
                                </div>
                                <div className="flex justify-end items-center">
                                    <FontAwesomeIcon className="text-[4pt] mr-[1px]" icon={faSignal4} />
                                    <FontAwesomeIcon className="text-[4pt] mr-[1.7px]" icon={faWifi3} />
                                    <FontAwesomeIcon className="text-[4pt] ml-[1px] mt-[0.5px]" icon={faBattery3} />
                                </div>
                            </div>

                            <div className="shrink-0 grow-0 w-full h-[21px] text-zinc-800 px-[5px] pt-[2px] pb-[4px]">
                                <div className="bg-zinc-200 rounded-[5px] w-full h-full text-[6px] flex items-center justify-center gap-1">
                                    <FontAwesomeIcon className="text-zinc-500" icon={faLock} />
                                    reonic.com
                                </div>
                            </div>
                        </div>
                    )}
                    {children}
                </div>
                <div className="absolute top-[-1px] w-full flex justify-center z-20">
                    <div className={`w-[50px] h-[10px] rounded-b-[5px] bg-black`} />
                </div>
                <div className="absolute bottom-0 w-full flex justify-center h-1.5 z-50">
                    <div
                        className={`
                            h-[3px] w-[75px] rounded-full
                            ${whitebar ? "bg-black" : "bg-white"} 
                        `}
                    />
                </div>
            </div>
        </div>
    );
};
